import { useEffect, Suspense, lazy } from 'react';
import { Toaster } from 'react-hot-toast';
// Lazy load MainAppPage for better initial load
const MainAppPage = lazy(() => import('./pages/MainAppPage').then(m => ({ default: m.MainAppPage })));
import { BRAND } from './config/brand';
import { AnimatedBackground } from './components/ui/animated-background';
import { LiteModeProvider, useLiteMode } from './hooks/useLiteMode';
import { I18nProvider } from './i18n';

// Quick loading spinner component
const QuickLoader = () => (
  <div className="loading-overlay">
    <div className="quick-spinner" />
  </div>
);

function AppContent() {
  const { isLiteMode, isMobile } = useLiteMode();

  // Р”РѕР±Р°РІР»СЏРµРј/СѓР±РёСЂР°РµРј РєР»Р°СЃСЃ lite-mode РЅР° body
  useEffect(() => {
    if (isLiteMode) {
      document.body.classList.add('lite-mode');
    } else {
      document.body.classList.remove('lite-mode');
    }
    return () => {
      document.body.classList.remove('lite-mode');
    };
  }, [isLiteMode]);

  // Р’ lite mode СѓРјРµРЅСЊС€Р°РµРј РєРѕР»РёС‡РµСЃС‚РІРѕ С‡Р°СЃС‚РёС† РёР»Рё РїРѕР»РЅРѕСЃС‚СЊСЋ РѕС‚РєР»СЋС‡Р°РµРј С„РѕРЅ
  const particleCount = isLiteMode ? 0 : (isMobile ? 12 : 30);

  return (
    <div className="relative min-h-dvh bg-sheriff-bg flex flex-col">
      {/* Global Premium Animated Background - РѕС‚РєР»СЋС‡Р°РµРј РІ lite mode */}
      {!isLiteMode && (
        <div className="fixed inset-0 z-0 pointer-events-none" style={{ touchAction: 'none' }}>
          <AnimatedBackground 
            color="#d4af37" 
            particleCount={particleCount}
            className="opacity-50"
          />
        </div>
      )}

      {/* Main Content with Suspense for lazy loading */}
      {/* min-h-0 РєСЂРёС‚РёС‡РµСЃРєРё РІР°Р¶РµРЅ РґР»СЏ flex-РґРµС‚РµР№ С‡С‚РѕР±С‹ СЃРєСЂРѕР»Р» СЂР°Р±РѕС‚Р°Р» */}
      <div className="relative z-10 flex-1 flex flex-col min-h-0">
        <Suspense fallback={<QuickLoader />}>
          <MainAppPage />
        </Suspense>
      </div>
      
      {/* Toast notifications - Sheriff Barbershop theme */}
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 3000,
          style: {
            background: BRAND.colors.bgElevated,
            color: BRAND.colors.textPrimary,
            border: `1px solid ${BRAND.colors.primary}`,
            borderRadius: '0.75rem',
            padding: '1rem',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.5)',
          },
          success: {
            iconTheme: {
              primary: BRAND.colors.primary,
              secondary: BRAND.colors.bgDark,
            },
          },
          error: {
            iconTheme: {
              primary: BRAND.colors.error,
              secondary: BRAND.colors.bgDark,
            },
          },
        }}
      />
    </div>
  );
}

function App() {
  return (
    <LiteModeProvider>
      <I18nProvider>
        <AppContent />
      </I18nProvider>
    </LiteModeProvider>
  );
}

export default App;
